// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"879068e8","453":"4be4c986","455":"dc9bbb84","977":"f66196d7"}[chunkId] + ".chunk.js";
};